export default "__VITE_ASSET__GTQ8Yzlh__"